export const personal = {
  name: 'Mradul Kapoor',
  role: 'Full Stack Developer',
  tagline: 'Building modern web applications and intelligent systems with a strong focus on performance, clean code, and user experience. Experienced in React, Node.js, Android development, and AI-integrated products.',
  email: 'mradul.kapoor2004@gmail.com',
  phone: '+91 80810 00546',
  location: 'Lucknow, India',
  university: 'SRM IST, Delhi NCR',
  cgpa: '9.28',
  links: {
    github: 'https://github.com/mradull',
    linkedin: 'https://linkedin.com/in/mradull',
    leetcode: 'https://leetcode.com/Mradull',
  },
};

export const stats = [
  { num: '2+', label: 'Internships & Leaderships' },
  { num: '2',  label: 'Live projects' },
  { num: '3',  label: 'Hackathon wins' },
  { num: '1',  label: 'Research paper' },
];

export const aboutFocus = ['Full Stack Web', 'Android Dev', 'AI Integration', 'REST APIs'];
export const aboutInterests = ['DSA', 'Clean Code', 'Open Source', 'UI/UX'];

export const projects = [
  {
    id: 'triptailor',
    name: 'TripTailor',
    subtitle: 'AI Powered Travel Planner',
    status: 'live',
    statusLabel: 'Live',
    iconBg: '#e6ede6',
    year: '2024',
    desc: 'AI-powered travel planner integrating Mistral AI via OpenRouter for personalized itineraries with real-time city search. Features Google OAuth & Supabase Auth for secure login. Optimized API calls reducing redundant fetching by 30%.',
    fullDesc: 'TripTailor started as a frustration with generic travel itineraries that ignore personal preferences. The goal was simple: build a planner that actually knows you. Powered by Mistral AI via OpenRouter, it generates day-by-day itineraries tailored to your travel style, budget, and interests — all in real time.',
    problem: 'Existing travel planners are either too generic or too complex. Travelers spend hours stitching together Google searches, blog posts, and maps just to plan a weekend trip.',
    solution: 'A single interface where you describe your trip and get a complete, personalized itinerary instantly. Real-time city search, AI-generated day plans, and secure authentication make it feel like a personal travel assistant.',
    outcome: 'Reduced redundant API calls by 30% through smart caching. Integrated Google OAuth for frictionless login. Live and used by real travelers.',
    metrics: [
      { num: '30%', label: 'Reduction in API calls' },
      { num: '< 2s', label: 'Itinerary generation time' },
      { num: '100%', label: 'Offline auth support' },
    ],
    tags: ['React.js', 'Node.js', 'Supabase', 'OpenRouter AI', 'Google OAuth', 'Mistral AI'],
    liveUrl: 'https://trip-tailor-n6tnffv1m-mradul-kapoors-projects.vercel.app/',
    codeUrl: 'https://github.com/Mradull/TripTailor',
    images: [
      { label: 'Home screen', color: '#e8f0e8' ,src: '/triptailor1.png'},
      { label: 'Itinerary view', color: '#e8e8f0' ,src: '/triptailor2.png'},
      { label: 'Login screen', color: '#f0e8e8' ,src: '/triptailor3.png'},
    ],
  },
  {
  id: 'nova',
  name: 'N.O.V.A.',
  subtitle: 'AI Voice Automation Assistant',
  status: 'wip',
  statusLabel: 'Ongoing',
  iconBg: '#f0e8e0',
  year: '2024',

  desc: 'JARVIS-inspired AI voice assistant capable of system automation, real-time voice interaction, app control, web search, meeting scheduling, screenshots, and hands-free desktop operations using offline-first architecture.',

  fullDesc: 'N.O.V.A. is a JARVIS-style intelligent voice assistant designed to control and automate everyday desktop tasks through natural voice commands. Built with an offline-first architecture, it can open applications, search YouTube or Google, take screenshots, control system functions, schedule meetings, and execute real-time commands — all through seamless two-way voice interaction. The project combines speech recognition, task automation, and a custom interactive interface to create a fast, private, and futuristic desktop assistant experience.',

  problem: 'Traditional voice assistants are heavily cloud-dependent, limited in desktop-level automation, and often lack deep personalization or offline capabilities for productivity-focused workflows.',

  solution: 'An intelligent desktop assistant that combines local speech recognition, voice feedback, and automation modules to perform real-world system tasks such as opening applications, controlling settings, searching the web, scheduling reminders, taking screenshots, and executing voice-driven workflows.',

  outcome: 'Successfully built a working desktop assistant capable of handling real-time voice commands, system automation, web interactions, and productivity tasks through a custom interactive interface and extensible backend architecture.',

  metrics: [
    { num: '15+', label: 'Voice automation commands' },
    { num: '<1s', label: 'Wake-word response time' },
    { num: '100%', label: 'Hands-free workflow support' },
  ],

  tags: [
    'Python',
    'FastAPI',
    'Tkinter',
    'SpeechRecognition',
    'Pyttsx3',
    'Automation',
    'Voice AI',
    'System Control'
  ],

  liveUrl: null,
  codeUrl: '#',

  images: [
    { label: 'Assistant GUI', src: '/nova-gui.png' },
    { label: 'Voice command interface', src: '/nova-command.png' },
  ],
},
  {
  id: 'suraksha',
  name: 'Suraksha',
  subtitle: 'Women Safety App',
  status: 'built',
  statusLabel: 'Built',
  iconBg: '#f0e8ea',
  year: '2023',

  desc: 'Android-based women safety application featuring real-time emergency alerts, live location sharing, SOS activation, and Firebase-powered authentication for secure and reliable access.',

  fullDesc: 'Suraksha is a smart women safety application designed to provide quick emergency assistance during critical situations. The app enables users to instantly trigger SOS alerts, share live location with trusted contacts, and access emergency support features through a simple and responsive interface. Built using Firebase services and Android technologies, the project focuses on reliability, accessibility, and real-time communication to enhance personal safety.',

  problem: 'In emergency situations, users often struggle to quickly contact trusted people, share their live location, or access safety resources efficiently. Existing solutions are either too complex or lack reliable real-time communication features.',

  solution: 'Developed an Android application with one-tap SOS triggering, live GPS location sharing, emergency contact integration, and secure Firebase authentication to provide fast and reliable emergency assistance.',

  outcome: 'Successfully built a real-time safety platform capable of sending emergency alerts, sharing live location instantly, and improving accessibility during high-stress situations through an intuitive mobile experience.',

  metrics: [
    { num: 'Real-time', label: 'Location tracking' },
    { num: '<2s', label: 'SOS alert triggering' },
    { num: '24/7', label: 'Emergency accessibility' },
  ],

  tags: [
    'Android',
    'Firebase',
    'Google Maps API',
    'Java',
    'Location Tracking',
    'Safety App'
  ],

  liveUrl: null,
  codeUrl: 'https://github.com/Mradull/women-safety-app',

  images: [
    { label: 'Emergency dashboard', src: '/suraksha2.jpeg' },
    { label: 'SOS & live tracking', src: '/suraksha1.jpeg' },
    { label: 'Hidden Camera Detection', src: '/suraksha3.jpeg' }
  ],
},
  {
  id: 'kahoot-clone',
  name: 'Kahoot Clone',
  subtitle: 'Real-time Multiplayer Quiz Platform',
  status: 'built',
  statusLabel: 'Built',
  iconBg: '#ede8f5',
  year: '2024',

  desc: 'Interactive real-time quiz platform inspired by Kahoot, featuring multiplayer gameplay, live score tracking, room-based sessions, and dynamic question management with seamless user experience.',

  fullDesc: 'Kahoot Clone is a real-time multiplayer quiz application built to recreate the engaging classroom and event experience of live quiz platforms. Users can create or join quiz rooms, answer questions in real time, and compete on a live leaderboard with instant score updates. The project focuses on fast interactions, responsive UI, and synchronized gameplay to deliver a smooth and competitive multiplayer experience.',

  problem: 'Traditional quiz systems often lack real-time interaction, engaging multiplayer experiences, and seamless synchronization between participants during live sessions.',

  solution: 'Developed a room-based multiplayer quiz platform with real-time communication, live leaderboards, instant answer validation, and dynamic question flow to create an interactive and competitive learning environment.',

  outcome: 'Successfully built a fully functional multiplayer quiz system capable of handling synchronized gameplay, live scoring, and smooth participant interaction across multiple users in real time.',

  metrics: [
    { num: 'Real-time', label: 'Multiplayer gameplay' },
    { num: '<1s', label: 'Scoreboard updates' },
    { num: '100%', label: 'Responsive interface' },
  ],

  tags: [
    'React.js',
    'Node.js',
    'Socket.IO',
    'JavaScript',
    'Real-time Systems',
    'Multiplayer'
  ],

  liveUrl: 'https://kahoot-iota.vercel.app/',
  codeUrl: 'https://github.com/Mradull/Kahoot',

  images: [
    { label: 'Dashboard', src: '/kahoot1.png' },
    { label: 'Quiz Page', src: '/kahoot2.png' },
    { label: 'Live leaderboard', src: '/kahoot3.png' }
  ],
},
];

export const skills = [
  { name: 'React.js',      category: 'Frontend',  level: 90 },
  { name: 'Node.js',       category: 'Backend',   level: 85 },
  { name: 'JavaScript',    category: 'Language',  level: 88 },
  { name: 'Java',          category: 'Language',  level: 82 },
  { name: 'Python',        category: 'Language',  level: 75 },
  { name: 'MongoDB',       category: 'Database',  level: 80 },
  { name: 'Supabase',      category: 'Database',  level: 78 },
  { name: 'Express.js',    category: 'Backend',   level: 83 },
  { name: 'Android',       category: 'Mobile',    level: 80 },
  { name: 'Firebase',      category: 'Platform',  level: 77 },
  { name: 'Git & GitHub',  category: 'Tools',     level: 88 },
  { name: 'REST APIs',     category: 'Concepts',  level: 87 },
  { name: 'C++',           category: 'Language',  level: 72 },
  { name: 'Kotlin',        category: 'Mobile',    level: 70 },
  { name: 'Vercel/Render', category: 'Deploy',    level: 82 },
];

export const experience = [
  {
    id: 'molog',
    role: 'Software Developer Intern',
    company: 'Molog',
    location: 'Gurgaon, India',
    period: 'May 2024 – Jul 2024',
    bullets: [
      'Engineered an Android app with Socket.IO to stream real-time video frames and synchronize scheduled ads across devices.',
      'Designed a monitoring app to display active screens and dynamically showcase currently playing advertisements.',
      'Established robust REST API interactions using Retrofit and Volley, validated through Postman.',
      'Collaborated with web team on cross-platform media sync, reducing playback discrepancies by 20%.',
    ],
  },
  {
    id: 'csi',
    role: 'Android Development Lead',
    company: 'Computer Society of India (CSI)',
    location: 'SRM IST, India',
    period: 'Jan 2023 – Jan 2024',
    bullets: [
      'Guided peers on advanced Android topics: Retrofit API integration, Firebase services, Kotlin, and UI/UX optimization.',
      'Facilitated technical workshops on mobile development trends and UI/UX best practices for student developers.',
    ],
  },
  {
  id: 'ngo',
  role: 'Volunteer Intern',
  company: 'Pledge a Smile Foundation',
  location: 'Dwarka, Delhi',
  period: 'June 2024 – July 2024',

  bullets: [
    'Contributed to fundraising initiatives, social media marketing campaigns, and community outreach programs for the foundation.',
    
    'Assisted in development and volunteer coordination activities to support individuals and communities in need through organized social impact efforts.',
  ],
}
];

export const achievements = [
  { icon: '🏆', title: 'Winner — Sparksprint Ideathon', sub: 'by ISTE VIT Vellore' },
  { icon: '⚡', title: 'Winner — Geek Tank Hackathon', sub: 'by GeeksforGeeks' },
  { icon: '🥇', title: '1st Place — Error Hunt', sub: 'Coding Competition' },
];

export const certifications = [
  'Certified Full Stack Web Developer — Udemy',
  'DBMS — NPTEL / IIT',
  'Google Android Developer — AICTE Eduskills',
];

export const education = [
  {
    degree: 'B.Tech — Computer Science & Engineering',
    school: 'SRM Institute of Science and Technology',
    meta: 'Delhi NCR · Expected May 2026',
    grade: 'CGPA 9.28 / 10',
  },
  {
    degree: 'Class XII (ISC)',
    school: "St. Mary's Convent Inter College",
    meta: 'Lucknow, India · April 2022',
    grade: '90.4%',
  },
  {
    degree: 'Class X (ICSE)',
    school: "St. Mary's Convent Inter College",
    meta: 'Lucknow, India · April 2022',
    grade: '94.5%',
  },
];
